import { HomeOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { FC } from 'react';

export const NotFound: FC = () => {
  return (
    <div className="bg-gray-100 flex items-center justify-center min-h-screen">
      <div className="text-center">
        <h1 className="text-7xl font-extrabold text-orange-500">404</h1>
        <p className="text-2xl font-medium text-gray-800 mt-4">
          Page Not Found
        </p>
        <p className="text-gray-600 mt-2">
          Sorry, the page you're looking for doesn't exist.
        </p>
        <Button
          href="/"
          size="large"
          variant="filled"
          type="primary"
          className="mt-6 font-semibold"
          icon={<HomeOutlined />}
        >
          Go Back Home
        </Button>
      </div>
    </div>
  );
};
